export const FEATURES = {
  jobs: true,
  forum: true,
  pricing: true,
} as const;
